import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.33333 6C0.596954 6 0 6.59695 0 7.33333C0 8.06971 0.596954 8.66667 1.33333 8.66667H22.6667C23.403 8.66667 24 8.06971 24 7.33333C24 6.59695 23.403 6 22.6667 6H1.33333ZM1.33333 14.3359C0.596954 14.3359 0 14.9329 0 15.6693C0 16.4057 0.596954 17.0026 1.33333 17.0026H22.6667C23.403 17.0026 24 16.4057 24 15.6693C24 14.9329 23.403 14.3359 22.6667 14.3359H1.33333Z"
	})]
});
const ForwardRef = forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
